<app-ace-select [appendTo]="DROPDOWN_HOLDER_SELECTOR"
                [items]="options"
                [bindValue]="valueKey"
                [bindLabel]="labelKey"
                [placeholder]="placeholder() ?? ('Duration' | messageTranslate)"
                [multiSelect]="multiSelect()"
                [maxSelectedLabels]="maxSelectedLabels()"
                [maxSelectedItemName]="maxSelectedItemName()"
                [maxSelectedShowItemName]="true"
                [hideSelected]="false"
                [showClearItem]="true"
                [truncateLabels]="true"
                [closeOnSelect]="!multiSelect()"
                (openEvent)="onOpenEvent($event)"
                (closeEvent)="onCloseEvent($event)"/>
